import { render, staticRenderFns } from "./PatientSim.vue?vue&type=template&id=38458a02&scoped=true"
import script from "./PatientSim.vue?vue&type=script&lang=js"
export * from "./PatientSim.vue?vue&type=script&lang=js"
import style0 from "./PatientSim.vue?vue&type=style&index=0&id=38458a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38458a02",
  null
  
)

export default component.exports